module.exports = __webpack_public_path__ + "img/ES1493.ecb7b971.png";